import * as classNames from 'classnames';
import * as React from 'react';

import * as Bulma from './../../../bulma';
import { withHelpersModifiers } from './../../../bulma';

export interface ModalCardTitle<T> extends Bulma.Tag, React.HTMLProps < T > {}

export function ModalCardTitle({ tag = 'h1', ...props }: ModalCardTitle<HTMLElement>) {
    const className = classNames('modal-card-title', props.className);

    return React.createElement(tag, { ...props, className });
}

const HOC = /*@__PURE__*/withHelpersModifiers(ModalCardTitle);
export default HOC;



// WEBPACK FOOTER //
// ./src/components/Modal/Card/ModalCardTitle.tsx